import api, { toForm } from './api'

export const memberService = {
  getProfile () {
    return api.get('/api/member/getUserProfile')
  },

  getMemberInfo () {
    return api.get('/api/member/get-member-info')
  },

  // Backend requires the password pair on every profile update.
  updateProfile ({ fullname, email, contactNumber, password, passwordConfirmation }) {
    return api.post('/api/member/updateProfile', toForm({
      fullname,
      email,
      contact_number: contactNumber,
      password,
      password_confirmation: passwordConfirmation
    }))
  },

  changePassword ({ oldPassword, password }) {
    return api.post('/api/member/change-password', toForm({ old_password: oldPassword, password }))
  },

  setLanguage (language) {
    return api.post('/api/member/setLanguage', toForm({ language }))
  }
}
